import {getBaseUrl} from '../../utils';
import io from '../../lib/io'


export async function getAll() {
  return await io.get(`${getBaseUrl()}/admin/users`);
}


export async function add(data) {
  return await io.post(`${getBaseUrl()}/admin/create-user`, data);
}


export async function save(id, data) {
  return await io.post(`${getBaseUrl()}/admin/users/${id}/edit`, data);
}


export async function getById(id) {
  return await io.get(`${getBaseUrl()}/admin/users/${id}`);
}

export async function remove(id) {
  return await io.post(`${getBaseUrl()}/admin/users/${id}/delete`);
}


export default {
  getAll,
  add,
  save,
  getById,
  remove,
}
